import { FC, PropsWithChildren } from 'react';

// Logged-out footer shell. Replaces the shared Fela FooterContainer + <Container>
const FooterContainer: FC<PropsWithChildren> = ({ children }) => (
  <footer className="bcfoot" data-name="footer">
    <div>{children}</div>
  </footer>
);

export default FooterContainer;
